"use client";

import React from "react";
import Text from "@components/atoms/Text";
import styles from "./PriceByVariantSection.module.scss";
import { PageType } from "@constants/pageTypes";
import PriceByVariantSectionClientWrapper from "./PriceByVariantSectionClientWrapper";
import { formatToLakhs } from "@utils/numberFormatter";

interface PriceByVariantSectionProps {
  variantsDetails: any;
  carName: string;
  isLoggedIn: boolean;
  city: any;
  brandName: string;
  modelName: string;
  isSellable: boolean;
  pageType?: PageType;
  carAvailability?: string;
  savingBalance?: any;
}

export default function PriceByVariantSection({
  variantsDetails,
  carName,
  isLoggedIn,
  city,
  brandName,
  modelName,
  isSellable,
  pageType,
  carAvailability,
  savingBalance,

}: PriceByVariantSectionProps) {
  const cityName = city?.name;

  return (
    <div className={styles.sectionWrapper}>
      <div className={styles.headingWrapper}>
        <Text level="h2" className={styles.heading}>
          {`${brandName} ${modelName} Price in ${cityName} (Variantwise)`}
        </Text>
        <Text level="p" className={styles.subheading}>
          {`The ${brandName} ${modelName} price in ${cityName} starts at ₹${formatToLakhs(variantsDetails[0]?.onRoadPrice)} L for the base variant and goes up to ₹${formatToLakhs(variantsDetails[variantsDetails.length - 1]?.onRoadPrice)} L for the top-spec variant. Please note that these prices include the GST savings under the revised tax structure.`}
        </Text>
      </div>

      <PriceByVariantSectionClientWrapper
        variantsDetails={variantsDetails}
        carName={carName}
        isLoggedIn={isLoggedIn}
        city={city}
        brandName={brandName}
        modelName={modelName}
        isSellable={isSellable}
        pageType={pageType}
        carAvailability={carAvailability}
        savingBalance={savingBalance}
      />
    </div>
  );
}
